import { useState } from 'react';
import styled from 'styled-components';

import { Region } from '../../data/words';
import { setAutoSubmit, setRegion } from '../../reducers/settings';
import { autoSubmitSelector, regionSelector } from '../../selectors/settings';
import { useAppDispatch, useAppSelector } from '../../store';

import { SettingsLabel } from './SettingsLabel';
import { SettingsRow } from './SettingsRow';
import { SettingsToggle } from './SettingsToggle';

const Wrapper = styled.div`
  margin: 32px 16px 0 16px;
`;
const SettingsTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
  color: #212121;
`;

export const Settings = (): JSX.Element => {
  const dispatch = useAppDispatch();

  const autoSubmit = useAppSelector(autoSubmitSelector);
  const region = useAppSelector(regionSelector);

  const [expanded, setExpanded] = useState(false);

  const onClickTitle = (): void => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const onClickUk = (): void => {
    dispatch(setRegion(Region.UK));
  };

  const onClickUs = (): void => {
    dispatch(setRegion(Region.US));
  };

  const onClickAutoSubmit = (): void => {
    dispatch(setAutoSubmit(true));
  };

  const onClickPressEnter = (): void => {
    dispatch(setAutoSubmit(false));
  };

  return (
    <Wrapper>
      <SettingsTitle onClick={onClickTitle}>Settings</SettingsTitle>
      {expanded ? (
        <>
          <SettingsLabel>Spelling</SettingsLabel>
          <SettingsRow>
            <SettingsToggle selected={region === Region.UK} onClick={onClickUk}>
              🇬🇧 UK English
            </SettingsToggle>
            <SettingsToggle selected={region === Region.US} onClick={onClickUs}>
              🇺🇸 US English
            </SettingsToggle>
          </SettingsRow>
          <SettingsLabel>Submitting a guess</SettingsLabel>
          <SettingsRow>
            <SettingsToggle selected={autoSubmit} onClick={onClickAutoSubmit}>
              Automatic
            </SettingsToggle>
            <SettingsToggle selected={!autoSubmit} onClick={onClickPressEnter}>
              Press enter
            </SettingsToggle>
          </SettingsRow>
        </>
      ) : null}
    </Wrapper>
  );
};
